<template>
  <div class="elevation-2">
    <pulse-zones-form v-if="edit" :pulse-zones="pulseZones" @success="edit=false;$emit('success')"></pulse-zones-form>
    <table class="v-table pzone-table" v-if="!edit">
      <thead>
        <tr class="primary theme--dark">
          <th>Strefy tętna</th>
          <th>Progi</th>
        </tr>
      </thead>
      <tbody>
        <tr class="blue-grey lighten-4">
          <th>
            Regeneracji aktywnej
          </th>
          <td>
            {{ pulseZones.zone_1 }}
          </td>
        </tr>
        <tr class="light-blue lighten-3">
          <th>
            Niskiej intensywności
          </th>
          <td>
            {{ pulseZones.zone_1 }} - {{ pulseZones.zone_2 }}
          </td>
        </tr>
        <tr class="light-blue lighten-1">
          <th>
            Próg tlenowy
          </th>
          <td>
            {{ pulseZones.zone_2 }}
          </td>
        </tr>
        <tr class="green lighten-1">
          <th>
            Średniej intensywności
          </th>
          <td>
            {{ pulseZones.zone_2 }} - {{ pulseZones.zone_3 }}
          </td>
        </tr>
        <tr class="yellow lighten-1">
          <th>
            Wysokiej intensywności
          </th>
          <td>
            {{ pulseZones.zone_3 }} - {{ pulseZones.zone_4 }}
          </td>
        </tr>
        <tr class="orange lighten-1">
          <th>
            Próg anaerobowy
          </th>
          <td>
            {{ pulseZones.zone_4 }}
          </td>
        </tr>
        <tr class="red lighten-1">
          <th>
            Wysokiej intensywności interwałowej
          </th>
          <td>
            {{ pulseZones.zone_4 }} - {{ pulseZones.hrmax }}
          </td>
        </tr>
        <tr class="red darken-1">
          <th>
            HRmax
          </th>
          <td>
            {{ pulseZones.hrmax }}
          </td>
        </tr>
      </tbody>
    </table>
    <v-toolbar color="primary" flat dark dense>
      <v-toolbar-title><div class="body-2">Data badania: {{ pulseZones.test_date | formatDate('LL') }}</div></v-toolbar-title>
          <v-spacer></v-spacer>
          <rp-icon
            v-if="isActiveRunnerTrainer || isActiveRunner"
            type="edit"
            tooltip="edytuj"
            dark
            @click="edit = !edit"
          />
          <rp-icon
            v-if="isActiveRunnerTrainer || isActiveRunner"
            type="delete"
            tooltip="usuń"
            dark
            @click="$emit('remove-pulse-zones'); edit=false"
          />
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PulseZonesForm from './PulseZonesForm'

export default {
  components: {PulseZonesForm},
  props: {
    pulseZones: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      edit: false
    }
  },
  computed: {
    ...mapGetters(['isActiveRunnerTrainer', 'isActiveRunner'])
  }
}
</script>
<style lang="scss" scoped>
table.v-table.pzone-table {
  thead {
    th {
      color: #fff;
      font-weight: 700;
    }
  }
  td {
    text-align: center;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/physical_tests/PulseZones.vue